import { ViewLOSV1EventManagePage } from "./ViewLOSV1EventManagePage";

export default ViewLOSV1EventManagePage;
